@if (hasSubscribePermission) {
  <button
    class="community-feed-item-subscribe"
    [ngClass]="{'active': item.subscriptions?.subscribed_by_current_user}"
    (click)="subscribeToggle()"
    [attr.aria-label]="title">
    <i class="material-icons subscribe-icon" aria-hidden="true">
      {{item.subscriptions?.subscribed_by_current_user ? 'notifications_active' : 'notifications'}}
    </i>
  </button>
}